import { render } from "./LanguageSwitcher.vue?vue&type=template&id=03bb1a09&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=03bb1a09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bb1a09"],['__file',"src/components/LanguageSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03bb1a09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03bb1a09', __exports__)) {
    api.reload('03bb1a09', __exports__)
  }
  
  module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=03bb1a09&scoped=true", () => {
    api.rerender('03bb1a09', render)
  })

}


export default __exports__